import { FiCheck } from "react-icons/fi";
import InfoTooltip from "newui/components/InfoTooltip";

interface StepHeaderItem {
	name: string;
	description?: string;
	enabled: boolean;
}

interface StepperHeaderProps {
	currentStep: number;
	steps: StepHeaderItem[];
}

export const StepperHeader: React.FC<StepperHeaderProps> = ({ steps, currentStep }) => {
	const getStepState = (index: number, enabled: boolean): "active" | "completed" | "disabled" | "inactive" => {
		if (index === currentStep) {
			return "active";
		}
		if (index < currentStep) {
			return "completed";
		}
		if (!enabled) {
			return "disabled";
		}
		return "inactive";
	};

	const circleClasses: Record<string, string> = {
		active: "bg-utility-brand-700 text-white",
		completed: "bg-utility-success-700 text-white",
		disabled: "bg-primary-100 text-primary-300",
		inactive: "bg-primary-200 text-primary-500",
	};

	const textClasses: Record<string, string> = {
		active: "text-utility-brand-700 font-semibold",
		completed: "text-utility-success-700",
		disabled: "text-primary-300",
		inactive: "text-primary-500",
	};

	return (
		<div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-0 mb-6">
			{steps.map((step, index) => {
				const state = getStepState(index, step.enabled);
				return (
					<div
						key={index}
						className="flex sm:flex-1 items-center"
					>
						<div className="flex flex-col sm:flex-row items-center sm:flex-1">
							<div className="flex items-center gap-2">
								<div
									className={`flex items-center justify-center w-8 h-8 rounded-full text-sm font-medium flex-shrink-0 ${circleClasses[state]}`}
								>
									{state === "completed" ? (
										<FiCheck size={16} />
									) : (
										<span>{index + 1}</span>
									)}
								</div>
								<div className="relative pr-6">
									<span className={`text-sm ${textClasses[state]}`}>
										{step.name}
									</span>
									{step.description && (
										<span className="absolute -top-1 right-0">
											<InfoTooltip tooltipText={step.description} size={18} />
										</span>
									)}
								</div>
							</div>
						</div>
						{index < steps.length - 1 && (
							<div className="hidden sm:block h-px flex-1 bg-gray-200 mx-2" />
						)}
					</div>
				);
			})}
		</div>
	);
};
